import _keys from "ramda/es/keys";
import _assoc from "ramda/es/assoc";
import _reduce from "ramda/es/reduce";
import _curry from "ramda/es/curry";
export default _curry(function (keysMap, obj) {
  return _reduce(function (acc, key) {
    return _assoc(keysMap[key] || key, obj[key], acc);
  }, {}, _keys(obj));
});